import { render, staticRenderFns } from "./UnitsCrisis.vue?vue&type=template&id=1cbdacc2&scoped=true"
import script from "./UnitsCrisis.vue?vue&type=script&lang=js"
export * from "./UnitsCrisis.vue?vue&type=script&lang=js"
import style0 from "./UnitsCrisis.vue?vue&type=style&index=0&id=1cbdacc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbdacc2",
  null
  
)

export default component.exports